import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import Settings from "./Settings"

const options: AxiosRequestConfig = {
  headers: { "Content-Type": "application/json", accept: "text/plain" },
  // withCredentials: true, // Commented out - requires server to send Access-Control-Allow-Credentials: true
}

const getStoredToken = (): string => {
  return (
    localStorage.getItem("LogedUser") ||
    localStorage.getItem("token") ||
    ""
  )
}

const buildOptions = (
  params?: unknown,
  newOpts?: AxiosRequestConfig
): AxiosRequestConfig => {
  const token = getStoredToken()
  const baseHeaders = { ...(options.headers || {}) }
  const customHeaders = { ...(newOpts?.headers || {}) }
  const headers: Record<string, string> = {
    ...baseHeaders,
    ...customHeaders,
  } as Record<string, string>

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`
  }

  if (params instanceof FormData) {
    delete headers["Content-Type"]
  }

  return {
    ...options,
    ...newOpts,
    headers,
  }
}

let isRedirecting = false

// Intercept 401 Unauthorized globally: clear invalid session & redirect to login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("LogedUser")
      localStorage.removeItem("token")
      const path = window.location.pathname
      if (!path.includes("/signin") && !isRedirecting) {
        isRedirecting = true
        window.location.href = "/signin"
      }
    }
    return Promise.reject(error)
  }
)

export const APIService = {
  postAction: async (
    endpoint: string,
    params?: unknown,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.post(
      Settings.BasePathForAPI + endpoint,
      params !== null ? params : null,
      buildOptions(params, newOpts)
    )
  },

  getAction: async (
    endpoint: string,
    params?: string,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.get(
      Settings.BasePathForAPI +
        endpoint +
        (params !== undefined && params !== null ? "?" + params : ""),
      buildOptions(undefined, newOpts)
    )
  },

  postActionExternal: async (
    endpoint: string,
    params?: unknown,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.post(
      endpoint,
      params !== null ? params : null,
      buildOptions(params, newOpts)
    )
  },

  getActionExternal: async (
    endpoint: string,
    newOpts?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.get(endpoint, newOpts)
  },
}

export default APIService
